/**
 * Shared constants for control-related components.
 */

export const frequencyOptions = [
  'annual',
  'half-yearly',
  'quarterly',
  'monthly',
  'semi-monthly',
  'weekly',
  'bi-weekly',
  'daily',
  'event-based',
];

export const controlTypeOptions = [
  { value: 'manual', label: 'Manual' },
  { value: 'automated', label: 'Automated' },
  { value: 'it-dependent-manual', label: 'IT Dependant Manual' },
];

export const significanceOptions = [
  { value: 'key', label: 'Key' },
  { value: 'non-key', label: 'Non-Key' },
];

export const classificationOptions = [
  { value: 'business', label: 'Business' },
  { value: 'itgc', label: 'ITGC' },
];

export const controlNatureOptions = [
  { value: 'preventive', label: 'Preventive' },
  { value: 'detective', label: 'Detective' },
];

export const assertionOptions = [
  { value: 'existence', label: 'Existence' },
  { value: 'accuracy & valuation', label: 'Accuracy & Valuation' },
  { value: 'occurence', label: 'Occurence' },
  { value: 'rights & obligation', label: 'Rights & Obligation' },
  { value: 'cut-off', label: 'Cut-off' },
  { value: 'presentation & disclosure', label: 'Presentation & Disclosure' },
  { value: 'completeness', label: 'Completeness' },
];

export const MAX_UPLOAD_FILE_SIZE_MB = 50;
export const MAX_UPLOAD_FILE_SIZE_BYTES = MAX_UPLOAD_FILE_SIZE_MB * 1024 * 1024;

export const testRunStatusOptions = [
  { value: 'all', label: 'All Statuses' },
  { value: 'passed', label: 'Passed' },
  { value: 'failed', label: 'Failed' },
  { value: 'warning', label: 'Warning' },
  { value: 'interrupted', label: 'Interrupted' },
];

export const dateRangeOptions = [
  { value: 'all', label: 'All Time' },
  { value: '7', label: 'Last 7 Days' },
  { value: '30', label: 'Last 30 Days' },
  { value: '90', label: 'Last 90 Days' },
];

export const validateFileSize = (file) => {
  if (file.size > MAX_UPLOAD_FILE_SIZE_BYTES) {
    return `File "${file.name}" exceeds the ${MAX_UPLOAD_FILE_SIZE_MB}MB limit (${(file.size / 1024 / 1024).toFixed(1)}MB)`;
  }
  return null;
};

export const validateFileSizes = (files) => {
  const errors = files.map(validateFileSize).filter(Boolean);
  return errors;
};
